import { IntlFormatFormatOptions } from 'date-fns';

export const SHORT_LOCALE_OPTIONS: IntlFormatFormatOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
};

export const LONG_LOCALE_OPTIONS: IntlFormatFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
};

export const LONG_DAY_LOCALE_OPTIONS: IntlFormatFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};
